import { OrderCheckApi } from '@/plugins/api'
import alert from '@/plugins/alert'

export default {
  namespaced: true,
  state: {
    ordersCheck: [],
    orderCheck: {},
    cart: [],
    count: 0,
  },
  actions: {
    async countOrdersCheck({ commit }, params) {
      const res = await OrderCheckApi.count(params)
      commit('setCount', res)
    },
    async fetchOrdersCheck({ commit }, params) {
      try {
        const res = await OrderCheckApi.fetch(params)
        commit('setOrdersCheck', res)
      } catch (error) {
        console.error(error)
      }
    },
    async createOrderCheck(_, data) {
      const res = await OrderCheckApi.create(data)
      return res
    },
    async fetchOneOrderCheck({ commit }, id) {
      const res = await OrderCheckApi.fetchOne(id)
      commit('setOrderCheck', res)
    },
    addToCart({ commit }, book) {
      commit('addToCart', book)
    },
    updateCart({ commit }, book) {
      commit('updateCart', book)
    },
    setOrderIndependence({ commit }, data) {
      commit('setOrderIndependence', data)
    },
    reset({ commit }) {
      commit('reset')
    },
    async update(_, { id, data }) {
      await OrderCheckApi.update(id, { ...data })
    },
  },
  mutations: {
    setOrdersCheck(state, payload) {
      state.ordersCheck = payload
    },
    setOrderCheck(state, payload) {
      state.orderCheck = payload
    },
    updateCart(state, payload) {
      const index = state.cart.findIndex((v) => v._id === payload._id)
      if (index !== -1) state.cart[index] = payload
    },
    addToCart(state, book) {
      const index = state.cart.findIndex((v) => v._id === book._id)
      if (index === -1) state.cart.push(book)
      else return alert.error('Sách đã tồn tạo trong giỏ hàng')
    },
    reset(state) {
      state.cart = []
      state.orderCheck = {}
    },
    setCount(state, data) {
      state.count = data
    },
    setOrderIndependence(state, data) {
      state.order = data
    },
  },
}
